// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__9u0pt","footer":"ModalUpdate_footer__3y4VR"};